export interface selectOption {
    label: string,
    value: number
}
export interface countrystatecityregion {
    cityData: any[];
    stateData: any[];
    regionData: any[];
    countryData: any[];
    subContinentData: any[];
    continentData: any[];
    genderData: any[];
}

export interface userrights {
    ID: number;
    MenuId: number;
    PageLink: string;
    URightAdd: boolean;
    URightEdit: boolean;
    URightExport: boolean;
    URightView: boolean;
}

export interface fileUpload {
    File?: object | null
    FileName: string
    FilePath: string
    Path: string
    Size: number
    type: string
    needToUpload: boolean
    DeleteFilePath?: string
}

export interface fileUploadSeq extends fileUpload {
    SeqNo: number;
}
export class fileUploadModal {
    File?: object | null;
    FileName: string;
    FilePath: string;
    Path: string;
    Size: number;
    type: string;
    needToUpload: boolean;

    constructor() {
        this.File = null
        this.FileName = ""
        this.FilePath = ""
        this.Path = ""
        this.Size = 0
        this.type = ""
        this.needToUpload = false;
    }
}

export interface tabCollection {
    id: number,
    idName: string,
    name: string,
    dataBsTarget: string,
    ariaControls: string,
    ariaSelected: boolean,
}